

import { computed, defineComponent, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import debounce from 'lodash.debounce';
import Dropdown from 'primevue/dropdown';
import HelperCustomComponentControls from '../../../functions/helperCustomComponentControls';
import Textarea from 'primevue/textarea';
import TextNodeConst from '../constants/TextNodeConst';
//import PrimeVue from "primevue/config";
export default defineComponent({
    name: 'custotextcontrol',
    components: {
        Dropdown,
        Textarea,
        //PrimeVue
    },
    props: {
        data: Object
    },
    setup(props) {
        const { showExpression } = HelperCustomComponentControls(props.data);
        const selectedText = ref('');


        let debounceUpdateData: any;
        const debounceTime = 1200;
       
    
        
  const initDebounce = () => {
    debounceUpdateData = debounce((data: any, start: boolean = false) => {
        if (props.data){
            props.data.onChange({ key: TextNodeConst.VAR_TEXT_IN, data: selectedText.value })        
        }
    }, debounceTime);
  }

  watch(
    selectedText, (newvalue, oldvalue) => {
          if (oldvalue !== newvalue && oldvalue !== undefined) {
              debounceUpdateData(newvalue, true);            
          }
        },
        {
          flush: 'post',
          //immediate: true, 
          deep: true
        }
      )


        onMounted(() => {
            if (props.data) {
                selectedText.value = props.data.variableTextInput
            }
            initDebounce();
        })


        onBeforeUnmount(() => {
            debounceUpdateData.cancel();
        })



      
        return {
            selectedText,
            showExpression,
            TextNodeConst
        };
    },
});
